<template>
  <div
    v-on-clickaway="close"
  >
    <div
      class="select-autocomplete"
      :class="{ 'select-autocomplete_error': error }"
    >
      <input
        v-bind="$attrs"
        :value="value"
        placeholder=""
        type="text"
        class="select-autocomplete__field"
        :class="{ 'select-autocomplete__field-active': value }"
        @input="onInput($event.target.value)"
        @focus="error = false"
      >
      <label
        v-if="label"
        class="select-autocomplete__label"
      >
        {{ label }}
        <span v-if="required" class="select__label-required">*</span>
      </label>

      <ul
        v-show="results.length > 0 && isShow"
        class="select-autocomplete__results"
      >
        <li
          v-for="(result, i) in results"
          :key="i"
          class="select-autocomplete__result"
          @click="setResult(result)"
        >
          {{ result.text }}
        </li>
      </ul>
      <transition name="slide-from-top">
        <span
          v-if="error && errorMsg"
          class="input__error-msg"
        >
          {{ errorMsg }}
        </span>
      </transition>
    </div>
  </div>
</template>

<script>
  import { mixin as clickaway } from 'vue-clickaway'
  import { config } from '@/config'
  import debounce from 'lodash/debounce'

  export default {
    name: 'BaseAutoComplete',
    mixins: [ clickaway ],
    props: {
      required: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      errorMsg: {
        type: String,
        default: ''
      },
      scrollbar: {
        type: String,
        default: 'custom'
      }
    },
    data () {
      return {
        error: null,
        isShow: false,
        value: '',
        results: []
      }
    },
    watch: {
      errorMsg: {
        handler (msg) {
          this.error = !!msg
        },
        immediate: true
      }
    },

    methods: {
      onInput: debounce(function (value) {
        this.$emit('input', value)
        if (value.length >= 1) {
          this.isShow = true
        } else {
          this.isShow = false
        }
        const app = this
        app.value = value
        window.axios.get(`${config.API}/fleet/model-list?model=${value}`).then(function (res) {
          app.results = res.data
        }).catch(function (e) {
          // console.log('Error' + e)
        })
      }, 500),
      setResult (result) {
        this.value = result.value
        this.$emit('input', this.value)
        this.isShow = false
      },
      close () {
        this.isShow = false
      }
    }
  }
</script>

<style lang="scss">
  .select-autocomplete {
    position: relative;
    min-width: 290px;
    padding-bottom: 28px;
    margin-bottom: 10px;
    &__label {
      position: absolute;
      top: 19px;
      left: 20px;
      z-index: 1;
      display: inline-block;
      padding-bottom: 1em;
      font-size: 16px;
      color: $c-black-mind;
      user-select: none;
      transition: all 0.2s;

      &-top {
        top: 6px;
        font-size: 10px;
        line-height: 20px;
        color: $c-gray;
      }

      &-required {
        color: $c-active-light;
      }
    }

    &__field {
      display: block;
      width: 100%;
      height: 56px;
      padding: 0 20px;
      padding-top: 14px;
      font-size: 18px;
      font-weight: 400;
      line-height: 30px;
      border: 1px solid $c-gray-light;
      outline: none;
      caret-color: $c-black;
      appearance: none;
      transition: 0.3s;
      border-radius: 0;

      &:invalid {
        box-shadow: none;
      }

      @include hover {
        background-color: $gray;
      }
      &:focus,&:not(:placeholder-shown) + .label, &-active {
        background-color: $c-white;
        box-shadow: 0 2px 10px 0 $c-shadow;

        +.select-autocomplete__label {
          top: 6px;
          font-size: 10px;
          line-height: 20px;
          color: $c-gray;
        }
      }
    }

    &__results {
      position: absolute;
      top: calc(100% - 28px);
      left: 0;
      z-index: 999;
      width: 100%;
      max-height: 235px;
      overflow: auto;
      list-style: none;
      border-bottom-right-radius: 4px;
      border-bottom-left-radius: 4px;
      box-shadow: 2px 2px 5px rgba($c-black, 0.1);
      transition: 0.3s;
      -webkit-overflow-scrolling: touch;
    }

    &__result {
      padding: 0.938em 1.3em;
      font-size: 16px;
      line-height: 1;
      cursor: pointer;
      background-color: $c-gray-extra-light-2;
      border-top: 1px solid $c-gray;
      transition: background-color 0.3s;

      @include hover {
        background-color: $c-gray;
      }
    }

    &_error {
      .select-autocomplete__field-input {
        padding-right: 3.5em;
        background-color: #fcded8;
      }

      .select-autocomplete__field::after {
        opacity: 1;
      }
    }
  }
</style>
